export const SOFTLINE_API_MDE_ARTIKELVORRAT_BEWEGUNGEN = '/v1/artikelvorrat/bewegung/entities'
export const SOFTLINE_API_MDE_ARTIKELVORRAT_ABSCHLUSS = '/v1/artikelvorrat/abschluss'
export const SOFTLINE_API_MDE_ARTIKELVORRAT_ARTIKEL = '/v1/artikelvorrat/artikel/entities'
export const SOFTLINE_API_MDE_ARTIKELVORRAT_KOPF = '/v1/artikelvorrat'
export const SOFTLINE_API_MDE_ARTIKELVORRAT_KOPF_ENTITES = '/v1/artikelvorrat/entities'
export const SOFTLINE_API_ARTIKELVORRAT_SCAN = '/v1/artikelvorrat/scan/{{code}}';
export const SOFTLINE_API_MDE_ARTIKELVORRAT_EINLESEN = '/v1/artikelvorrat/einlesen';
